module.exports = __webpack_public_path__ + "assets/img/cate.6f39e364.png";